import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";

import SearchHome from './components/SearchHome';
import ProductDetailPage from './components/ProductDetailPage';

const BrandSearch = (props) => {
    console.log("BrandSearch");

    const history = useHistory();
    const [custId, setCustId] = useState(props.custid);
    const [ProductId, setProductId] = useState(null);

    useEffect(() => {
        console.log("BrandSearch:useEffect:history: ", history);
        return history.listen((location) => {
            console.log("BrandSearch:useEffect:history:listen: ", location.pathname);
            sessionStorage.setItem("BrandSearchWidgetPath", location.pathname);
        })
    }, [history]);

    useEffect(() => {
        var result = sessionStorage.getItem("BrandSearchWidgetPath");
        console.log("BrandSearch:useEffect2: BrandSearchWidgetPath:", result);
        if (result != null) {
            history.push(result);
        }
    });

    useEffect(() => {
        let search = location.search;
        let params = new URLSearchParams(search);

        setProductId(params.get("productId"))
        console.log("BrandSearch:useEffect3: ProductId: ", ProductId);
        
    });

    return (
        <div>
        {(() => {
          if (ProductId) {
            return <ProductDetailPage productId={ProductId} />;
          } else {
            return <SearchHome pCustId={custId} />;
          }
        })()}
      </div>
    )
    
}

export default BrandSearch;